import R from 'ramda'
import {defineMessages} from 'react-intl'

import fetchLikes from '../api/fetchLikes'

import addNotification from './addNotification'

const messages = defineMessages({
  title: {
    id: 'An error happend', 
    defaultMessage: 'An error happened'
  },
  message: {
    id: "The list of estates your likes could not be retrieved, try again later", 
    defaultMessage: "The list of estates your likes could not be retrieved, try again later"
  }
})
const notification = {type: "error", message: messages.message, title: messages.title} 
const onComplete = (dispatch, estateIds) => (err, res) => {
  if(err) {
    dispatch(addNotification(notification))
    return console.error("Failed to fetch likes", err)
  }
  const allLikedEstates = R.pluck('estateId', res)
  const estateToMarkAsLiked = R.intersection(allLikedEstates, estateIds)
  dispatch({type: 'like_estates', estateToMarkAsLiked})
}

export default (estateIds) => (dispatch, getState) => {
  if(!R.path(['session', 'token'], getState())){
    return 
  }
  const userName = R.path(['session', 'userName'], getState())
  const token = R.path(['session', 'token'], getState())
  fetchLikes(userName, token, onComplete(dispatch, estateIds))
}



/** WEBPACK FOOTER **
 ** ./app/actions/fetchLikes.js
 **/